import React, { useCallback, useEffect, useMemo, useState } from 'react';
import { useNavigate } from 'react-router-dom'; // <-- import this
import PropTypes from 'prop-types';
import Container from '@mui/material/Container';
import { useForm, useTranslation } from 'hooks';
import { Loader, Section } from 'components/styledComponents';
import { Notification } from './forms';
import { Button, FooterActions } from './style';

function MyNotificationSettings({
  language,
  loading,
  notificationSettings,
  syncErrors,
  syncing,
  onSave,
  spinnerSize = '40'
}) {
  const { t } = useTranslation();
  const [syncInitiated, setSyncInitiated] = useState(false);
  const navigate = useNavigate(); // <-- use navigate hook

  const handleClose = useCallback(() => navigate('/'), [navigate]); // <-- replace history.push
  const handleSave = useCallback(
    data => {
      onSave(data);
      setSyncInitiated(true);
    },
    [onSave]
  );

  const { useInput, handleSubmit } = useForm({
    initialValues: useMemo(() => notificationSettings, [notificationSettings]),
    onSubmit: handleSave
  });

  useEffect(() => {
    if (syncInitiated && !syncing) {
      if (!syncErrors) handleClose();
      setSyncInitiated(false);
    }
  }, [handleClose, syncErrors, syncing, syncInitiated]);

  return (
    <React.Fragment>
      <Section>
        <Loader component={Container} loading={loading || syncing} spinnerSize={spinnerSize}>
          <Notification useInput={useInput} />
        </Loader>
      </Section>
      <Section>
        <Loader component={Container} loading={loading || syncing} spinnerSize={spinnerSize}>
          <FooterActions>
            <Button label={t('button.cancel')} variant="text" onClick={handleClose} />
            <Button
              color="primary"
              disabled={loading || syncing}
              label={t('button.save')}
              onClick={handleSubmit}
            />
          </FooterActions>
        </Loader>
      </Section>
    </React.Fragment>
  );
}

MyNotificationSettings.propTypes = {
  className: PropTypes.string,
  language: PropTypes.string.isRequired,
  loading: PropTypes.bool.isRequired,
  notificationSettings: PropTypes.object,
  syncErrors: PropTypes.oneOfType([PropTypes.object, PropTypes.string]),
  syncing: PropTypes.bool.isRequired,
  onSave: PropTypes.func.isRequired,
  spinnerSize: PropTypes.string
};

export default MyNotificationSettings;
